import React from "react";
import { Link } from "react-router-dom";
import { useApp } from "@/context/AppContext";

// Minimal global footer. Intentionally understated: a thin top border,
// soft ink-soft text, no columns. The only discoverable link today is
// the free Excel planner — rendered as a discreet underline so it
// doesn't compete with in-page CTAs. Rendered site-wide via App.js;
// Header is responsible for sticky chrome, Footer sits at the end of
// <main> so pages that are short still push the footer to the bottom
// visually without needing a flex layout.
export default function Footer() {
  const { t } = useApp();
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-border bg-surface-alt/40 mt-12"
    >
      <div className="max-w-5xl mx-auto px-5 py-6 flex flex-col sm:flex-row items-center sm:items-start justify-between gap-3 text-xs text-ink-soft font-sans">
        <p>© {new Date().getFullYear()} {t.app.name}</p>
        <nav className="flex items-center gap-4">
          <Link
            data-testid="footer-piano-excel-link"
            to="/piano-excel"
            className="hover:text-ink underline underline-offset-2 transition-colors"
          >
            {t.footer.pianoExcelLink}
          </Link>
        </nav>
      </div>
    </footer>
  );
}
